
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiLivelliEditorDialog extends Serenity.Extensions.GridEditorDialog<ProdottiLivelliRow> {
        protected getFormKey() { return ProdottiLivelliForm.formKey; }
        protected getIdProperty() { return ProdottiLivelliRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiLivelliRow.localTextPrefix; }

        protected form = new ProdottiLivelliForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //
            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            }

            return buttons;
        }
    }
}